var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"documents-list-view"},[(_vm.loaded)?_c('HubDocuments',{attrs:{"name":"document-list"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }